module.exports = __webpack_public_path__ + "media/images/icons/country_flags/kz-4d1d995b9e217181dcb816e29291ddf7.svg";